import i18n from "@/i18n"

const confirmModalMappings = {
  'finish-fleet-task': {
    title: () => i18n.t('fleetTaskInstant.confirmModal.finishAssignment.title'),
    alertText: () => i18n.t('fleetTaskInstant.confirmModal.finishAssignment.alertText'),
    confirmBtn: () => i18n.t('fleetTaskInstant.confirmModal.finishAssignment.confirmBtn'),
  },
  'scheduled-target-time-exist': {
    title: () => i18n.t('fleetTaskInstant.confirmModal.scheduledTargetTimeExist.title'),
    alertText: () => i18n.t('fleetTaskInstant.confirmModal.scheduledTargetTimeExist.alertText'),
    content: () => i18n.t('fleetTaskInstant.confirmModal.scheduledTargetTimeExist.content'),
    confirmBtn: () => i18n.t('fleetTaskInstant.confirmModal.scheduledTargetTimeExist.confirmBtn'),
  },
  'started-target-time-exist': {
    title: () => i18n.t('fleetTaskInstant.confirmModal.startedTargetTimeExist.title'),
    alertText: () => i18n.t('fleetTaskInstant.confirmModal.startedTargetTimeExist.alertText'),
    content: () => i18n.t('fleetTaskInstant.confirmModal.startedTargetTimeExist.content'),
    confirmBtn: () => i18n.t('fleetTaskInstant.confirmModal.startedTargetTimeExist.confirmBtn'),
  },
  'late-start-time': {
    title: () => i18n.t('fleetTaskInstant.confirmModal.lateStartTime.title'),
    alertText: () => i18n.t('fleetTaskInstant.confirmModal.lateStartTime.alertText'),
    content: () => i18n.t('fleetTaskInstant.confirmModal.lateStartTime.content'),
    confirmBtn: () => i18n.t('fleetTaskInstant.confirmModal.lateStartTime.confirmBtn'),
  },
}

export default confirmModalMappings
